/* eslint-disable complexity */
import sdkProvider from "../../utilities/sdk-provider";
import { requestHelper } from "../../utilities/request-helper";
import { trackPageEvent } from "../../utilities/trackPageEvent";
import { addNotification } from "../../state/draw-details/reducer";
import {
  genericError,
  alertAlreadyInDraw,
  alertPremierOnlyDraw,
} from "../../constants/notifications";

export const isAuthenticated = async () => {
  const identity = await sdkProvider("identity");
  return await identity.customer.isAuthenticated();
};

export const enterDrawWeb = async (drawId, variantId) => {
  localStorage.removeItem(`variantSelected${drawId}`);
  const identity = await sdkProvider("identity");
  const authHeader = await identity.getAuthHeader();
  const store = window.asos.webContext.getStoreId();

  await requestHelper.post({
    url: `/api/commerce/limiteddrops/v1/draws/me/${drawId}`,
    headers: {
      Authorization: authHeader,
      "Content-Type": "application/json",
    },
    body: {
      variantId: parseInt(variantId),
      store,
    },
  });
};

export const enterDrawAppFlow = (drawSlug, drawId, variantId) => {
  window.location.assign(
    `asos://limiteddrop/enter?slug=${drawSlug}&did=${drawId}&vid=${variantId}`
  );
};

export const setAndLogin = async (drawId, variantSelected) => {
  localStorage.setItem(`variantSelected${drawId}`, variantSelected);
  const identity = await sdkProvider("identity");
  identity.login();
};

export const getVariantSelected = (drawId) => () =>
  typeof window !== "undefined"
    ? localStorage.getItem(`variantSelected${drawId}`) ||
      getNativeAppsAlreadyEnteredVid() ||
      ""
    : "";

export const isNativeApp = () => {
  const params = new URLSearchParams(window.location.search);
  const appPlatform = params.get("app_platform");
  const appPlatforms = ["ios", "android"];
  return appPlatforms.includes(appPlatform);
};

export const getNativeAppsAlreadyEnteredVid = () => {
  const params = new URLSearchParams(window.location.search);
  const inapp = isNativeApp();
  const entered = params.get("entered") === "true";
  const vid = params.get("vid");
  return (inapp && entered && vid) || false;
};

const getErrorCode = (responseData) => {
  const error = Array.isArray(responseData) ? responseData[0] : responseData;
  return error?.errorCode;
};

export const errorNotification = (
  error,
  dispatch,
  date,
  termsAndConditionsLink,
  premierDeliveryPageLink
) => {
  const errorCode = getErrorCode(error.response?.data);

  if (errorCode) {
    const hasAlreadyEntered = errorCode === "AlreadyEntered";
    const premierOnly = errorCode === "PremierOnly";
    let analyticsMessage;

    switch (errorCode) {
      case "AlreadyEntered":
        analyticsMessage = "you already entered";
        break;
      case "TooLate":
        analyticsMessage = "draw is closed";
        break;
      case "WrongStore":
        analyticsMessage = "draw not available";
        break;
      case "PremierOnly":
        analyticsMessage = "premier only customers";
        break;
      default:
        analyticsMessage = "generic error";
        break;
    }

    if (hasAlreadyEntered) {
      dispatch(
        addNotification(alertAlreadyInDraw(date, termsAndConditionsLink))
      );
    } else if (premierOnly) {
      dispatch(addNotification(alertPremierOnlyDraw(premierDeliveryPageLink)));
    } else {
      dispatch(addNotification(genericError));
    }

    trackPageEvent({
      content: {
        layout: "limited-drops-message",
        message: analyticsMessage,
      },
    });
  } else {
    dispatch(addNotification(genericError));

    trackPageEvent({
      content: {
        layout: "limited-drops-message",
        message: "generic error",
      },
    });
  }
};
